<template>
  <TabelaOSD
    :colunas="resolvedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    @page-change="onPageChange"
    @sort-change="onSortChange"
    @reload="getParceiros"
  >
    <template #toolbar-actions>
      <ParceiroExport v-bind="pagination" :headers="headers" />
    </template>
    <template #toolbar-filters>
      <ParceiroFilters :loading="table.isLoading" @filter="onFilter" />
    </template>
    <template #cell-id="props">
      <span>
        <a
          class="btn btn-primary mx-1"
          title="Enviar Email" @click="enviarEmailCodigos(props.linha.id, props.linha.nome)"
        >
          <i class="bi bi-send" />
        </a>
        <a
          class="btn btn-success mx-1" :title="$t('criarCodigo')"
          @click="criarCodigoParceiro(props.linha.id, props.linha.nome)"
        >
          <i class="bi bi-plus-lg" />
        </a>
        <a
          class="btn btn-info mx-1" :title="$t('verCodigos')"
          @click="verCodigoParceiro(props.linha.id, props.linha.nome)"
        >
          <i class="bi bi-eye" />
        </a>
        <router-link v-slot="{ href, navigate }" :to="`/admin/parceiros/${props.linha.id}`" custom>
          <a :href="href" class="btn btn-primary mx-1" title="Editar" @click="navigate">
            <i class="bi bi-pencil-square" />
          </a>
        </router-link>
        <a class="btn btn-danger mx-1" title="Remover" @click="deleteParceiro(props.linha.id, props.linha.nome)">
          <i class="bi bi-trash" />
        </a>
      </span>
    </template>
  </TabelaOSD>
  <div>
    <DeleteParceiroModal ref="deleteParceiroModal" v-bind="selected" @update-table="getParceiros" />
    <EnviarEmailCodigosModal ref="enviarEmailCodigosModal" v-bind="selected" />
    <CriarCodigoParceiroModal ref="criarCodigoParceiroModal" v-bind="selected" />
    <VerCodigoParceiroModal ref="verCodigoParceiroModal" v-bind="selected" />
  </div>
</template>

<script>
import ParceiroExport from './ParceiroExport.vue';
import ParceiroFilters from './ParceiroFilters.vue';
import DeleteParceiroModal from './DeleteParceiroModal.vue';
import CriarCodigoParceiroModal from '@/modules/admin/parceiro/components/CriarCodigoParceiroModal.vue';
import VerCodigoParceiroModal from '@/modules/admin/parceiro/components/VerCodigoParceiroModal.vue';
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedParceiroData } from '../parceiroService';
import { useToast } from 'vue-toastification';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';
import { toPhone } from '@/modules/core/utils/formats';
import eventbus from '@/modules/core/services/eventbus';
import EnviarEmailCodigosModal from './EnviarEmailCodigosModal.vue';
export default {
  components: {
    ParceiroExport,
    ParceiroFilters,
    TabelaOSD,
    DeleteParceiroModal,
    CriarCodigoParceiroModal,
    VerCodigoParceiroModal,
    EnviarEmailCodigosModal,
  },
  data: () => ({
    selected: {
      id: '',
      nome: '',
    },
    table: {
      totalRows: 0,
      rows: [],
      columns: ref([
        {
          label: computed((_) => i18n.global.t('nome')),
          field: 'nome',
        },
        {
          label: computed((_) => i18n.global.t('telefone')),
          field: 'telefone',
          formatFn: toPhone,
        },
        {
          label: computed((_) => i18n.global.t('email')),
          field: 'email',
        },
        {
          label: computed((_) => i18n.global.t('quantidadeCodigos')),
          field: 'quantidadeCodigos',
        },
        {
          field: 'id',
          width: '261px',
          tdClass: 'text-center',
          globalSearchDisabled: true,
          sortable: false,
        },

      ]),
      mode: 'remote',
      class: 'osd-table',
      styleClass: 'vgt-table bordered condensed',
      compactMode: true,
      lineNumbers: true,
      paginationOptions: {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        nextLabel: '>',
        prevLabel: '<',
        infoFn: (params) => `
          ${params.firstRecordOnPage} - ${params.lastRecordOnPage} de ${params.totalRecords}
        `,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'nome', type: 'desc' },
      },
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'nome',
      order: 'desc',
      search: '',
    },
  }),
  computed: {
    resolvedColumns() {
      return this.table.columns.map((column) => ({
        ...column,
        label: column.label?.value ?? column.label,
      }));
    },
    headers() { return this.resolvedColumns.map((column) => column.label ?? ''); },
  },
  mounted() { eventbus.on('criar-codigo-parceiro', this.getParceiros); },
  unmounted() { eventbus.off('criar-codigo-parceiro', this.getParceiros); },
  methods: {
    deleteParceiro(id, nome) {
      this.selected.id = id;
      this.selected.nome = nome;
      this.$refs.deleteParceiroModal.show();
    },
    enviarEmailCodigos(id, nome) {
      this.selected.id = id;
      this.selected.nome = nome;
      this.$refs.enviarEmailCodigosModal.show();
    },
    criarCodigoParceiro(id, nome) {
      this.selected.id = id;
      this.selected.nome = nome;
      this.$refs.criarCodigoParceiroModal.show();
    },
    verCodigoParceiro(id, nome) {
      this.selected.id = id;
      this.selected.nome = nome;
      this.$refs.verCodigoParceiroModal.show();
    },
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    onPageChange(page) {
      this.updateParams({ page });
      this.getParceiros();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.updateParams({
        page: 1,
        sort: field,
        order: nextOrder,
      });
      this.getParceiros();
    },
    onFilter(filters) {
      this.updateParams({ ...filters, page: 1 });
      this.getParceiros();
    },
    async getParceiros() {
      this.table.isLoading = true;
      try {
        const data = await getPaginatedParceiroData(this.pagination);
        this.table.rows = data.dados;
        this.table.totalRows = data.total;
      } catch (error) {
        useToast().error(this.$t('erroAoObterDashboard'));
      }
      this.table.isLoading = false;
    },
  },
};
</script>
